import React from "react";
import { Box } from "@mui/material";
import ApplicationPrintCardInfoItem from "my-tax/components/application-print-card-info-item";

export const MyTaxDependentQualityInfo = () => {
  return (
    <Box style={{ padding: "16px" }}>
      <Box textAlign="center">{"Eltartotti minőség kódjai:"}</Box>
      <Box
        style={{
          color: "#919699",
          marginTop: "4px",
          lineHeight: "24px",
        }}
      >
        <ApplicationPrintCardInfoItem
          label="1."
          value="Kedvezményezett eltartott,"
        />
        <ApplicationPrintCardInfoItem label="2." value="Eltartott," />
        <ApplicationPrintCardInfoItem
          label="3."
          value="Felváltva gondozott gyermek,"
        />
        <ApplicationPrintCardInfoItem
          label="4."
          value="Tartósan beteg, illetve súlyosan fogyatékos személy (gyermek),"
        />
        <ApplicationPrintCardInfoItem
          label="5."
          value="Felváltva gondozott tartósan beteg, illetve súlyosan fogyatékos személy (gyermek),"
        />

        <ApplicationPrintCardInfoItem
          label="0."
          value="Kedvezménybe nem számító."
        />
      </Box>
    </Box>
  );
};

export default MyTaxDependentQualityInfo;
